import call from "../../call";
export default (function (opt) {
  return call('getStorage', opt);
});